import React, { createContext, useContext, useState, ReactNode } from "react";

interface WaitlistData {
  fname?: string;
  lname?: string;
  email?: string;
  phone?: string;
  referral_code?: string;
}

interface WaitlistContextType {
  waitlistData: WaitlistData;
  setWaitlistData: React.Dispatch<React.SetStateAction<WaitlistData>>;
}

const WaitlistContext = createContext<WaitlistContextType | undefined>(undefined);

export const WaitlistProvider = ({ children }: { children: ReactNode }) => {
  const [waitlistData, setWaitlistData] = useState<WaitlistData>({});
  return (
    <WaitlistContext.Provider value={{ waitlistData, setWaitlistData }}>
      {children}
    </WaitlistContext.Provider>
  );
};

export const useWaitlist = () => {
  const context = useContext(WaitlistContext);
  if (!context) throw new Error("useWaitlist must be used within WaitlistProvider");
  return context;
};
